import { type FC } from "react";

export interface EngagementOverviewHeaderProps {
  title: string;
  subtitle: string;
}

const EngagementOverviewHeader: FC<EngagementOverviewHeaderProps> = ({ title, subtitle }) => (
  <header className="engagement-overview-header">
    <div className="engagement-overview-header__copy">
      <h1 className="engagement-overview-header__title">{title}</h1>
      <p className="engagement-overview-header__subtitle">{subtitle}</p>
    </div>
  </header>
);

export default EngagementOverviewHeader;
